


















export const isSubclass=(ErrorClass,ParentClass)=>
ParentClass===ErrorClass||isProtoOf.call(ParentClass,ErrorClass);

const{isPrototypeOf:isProtoOf}=Object.prototype;